import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translations from './etEE.json';

i18n.use(initReactI18next).init({
  resources: {
    ee: {
      translation: translations,
    },
  },
  interpolation: {
    escapeValue: false,
  },
  lng: 'ee',
});

export default i18n;
